import React from 'react';
import { bool, number } from 'prop-types';
import { Box } from '@mui/material';
import { I18n } from 'utils/i18n';
import moment from 'moment';

const Information = ({ confirmedAt = null, isDigitalSignature = false }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      mb: '15px',
    }}
  >
    <Box
      component="span"
      sx={{
        color: 'primary.dark',
        fontSize: '12px',
        fontWeight: 500,
        textTransform: 'uppercase',
        mb: '8px',
      }}
    >
      {I18n.t(
        isDigitalSignature
          ? 'AcknowledgementReadModal.DIGITAL SIGNATURE'
          : 'AcknowledgementReadModal.MANDATORY READ',
      )}
    </Box>
    <Box
      component="span"
      sx={{
        fontSize: '14px',
        ...(confirmedAt
          ? { color: 'primary.dark' }
          : { color: '#8b98ab', textAlign: 'center', display: 'block' }),
      }}
    >
      {confirmedAt
        ? `${I18n.t(
            isDigitalSignature
              ? 'AcknowledgementReadModal.Digital signature made on'
              : 'AcknowledgementReadModal.Acknowledge made on',
          )} ${moment.unix(confirmedAt).format('LL')}`
        : I18n.t(
            isDigitalSignature
              ? 'AcknowledgementReadModal.Digital signature description'
              : 'AcknowledgementReadModal.Please, read what follows and confirm reception by clicking the button below',
          )}
    </Box>
  </Box>
);

Information.propTypes = {
  confirmedAt: number,
  isDigitalSignature: bool,
};

export default Information;
